export class CostReviewControlValves {
  numberOfValves!: number;
  manufacturer!: string;
  applications!: number[];
  unitsActuatorsFurnishedBy!: number;
  unitsActuatorsInstalledBy!: number;
  unitsActuatorsWiredBy!: number;
  isControlValvesApplicable!: boolean;
}
